import type { Context } from "@/types/FeedbackResult";

/** How many feedback groups (contexts) are correct out of all of them. A group can hold many tests. */
export type TestCounts = { correct: number; total: number };

/** The accepted and total number of `groups`, as the summary of a feedback tab shows them. */
export function countGroups(groups: Context[]): TestCounts {
    return { correct: groups.filter((g) => g.accepted).length, total: groups.length };
}
